module.exports = __webpack_public_path__ + "static/media/Andrea Fajardo Valerio.6d3cb831.png";